import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProjectsPage } from "@/features/projects/ProjectsPage";

const search = z.object({
  view: z.enum(["table", "cards"]).optional(),
});

export const Route = createFileRoute("/_app/projects/")({
  validateSearch: search,
  component: () => <ProjectsPage search={Route.useSearch()} />,
});
